import { render, staticRenderFns } from "./header-web.vue?vue&type=template&id=3185e4b9"
import script from "./header-web.vue?vue&type=script&lang=js"
export * from "./header-web.vue?vue&type=script&lang=js"
import style0 from "./header-web.vue?vue&type=style&index=0&id=3185e4b9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports